package one.healthium.profile.navigation.update_name

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.profile.ui.update_name.UpdateNameScreen

@Composable
fun UpdateNameContent(component: UpdateNameComponent) {
    CompositionLocalProvider(
        LocalViewModelStoreOwner provides component
    ) {
        UpdateNameScreen(component)
    }
}